
export class Global {
    public static Product_EndPoint = `LI161818122207_25EFProduct/`;
    public static InvLookUp_EndPoint = `/api/LookUp/`;
    public static GenLookUp_EndPoint = `api/LookUp/`;
    public static AccountsLookUp_EndPoint = `api/Lookup/`;
    public static CounterSalesInvoice_EndPoint = `api/LI210911101004_25EFCounterSalesInvoice/`;
  };